export const DISCOUNT_CONFIG = {
  // Set to true to enable NCC discount messaging, false for default messaging.
  showNCCMessaging: true,
  stores: {
    COM: "15",
    FR: "15",
    DE: "15",
    ES: "15",
    IT: "15",
    SE: "15",
    DK: "15",
    NL: "15",
    ROE: "15",
    US: "20",
    AU: "20"
  },
  countryOverrides: {
    IE: "15",
    CA: "20",
    MX: "20",
    SG: "20",
    HK: "20",
    MY: "20",
    TW: "20",
    CN: "20",
    ID: "20",
    KR: "20",
    SA: "20",
    KW: "20",
    QA: "20",
    EG: "20",
    TN: "20",
    OM: "20",
    MA: "20",
    JO: "20",
    BH: "20",
    DZ: "20",
    LB: "20",
    IQ: "20",
    PS: "20",
    AE: "20"
  }
};

export const getNCCDiscountValue = (storeCode, countryCode) => {
  if (!DISCOUNT_CONFIG.showNCCMessaging) {
    return { showNCCMessaging: false };
  }

  const discount =
    DISCOUNT_CONFIG.countryOverrides[countryCode] ||
    DISCOUNT_CONFIG.stores[storeCode];

  return discount
    ? { discount, showNCCMessaging: true }
    : { showNCCMessaging: false };
};
